module.exports = __webpack_public_path__ + "media/images/weather/301_night-e81fb5a96116ba6f1e20df264e883ff8.png";